import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id D938FAC2-CC48-431D-8019-FA41677470DD
 * name bottle-soda
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-soda.svg
 * tags
 * - Food / Drink 
 */
export const BottleSodaIcon = createSvgIcon(<><path d="M15 11V20A2 2 0 0 1 13 22H11A2 2 0 0 1 9 20V11A2 2 0 0 1 9.6 9.58C11.1 7.89 11 4 11 4H10V2H14V4H13S12.9 7.89 14.4 9.58A2 2 0 0 1 15 11Z" /></>, 'BottleSodaIcon');
export default BottleSodaIcon